exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mobileAppBanner__banner___2sHR_ {\n  padding: 6px 15px;\n  background-color: #e3e3e3; }\n  .mobileAppBanner__banner___2sHR_ .mobileAppBanner__message___1anh5 {\n    font-size: 11px;\n    width: calc(100% - 170px);\n    display: inline-block;\n    vertical-align: middle;\n    color: #a5a5a5;\n    font-weight: normal; }\n    .mobileAppBanner__banner___2sHR_ .mobileAppBanner__message___1anh5 .mobileAppBanner__appName___3lntp {\n      font-weight: 800; }\n  .mobileAppBanner__banner___2sHR_ .mobileAppBanner__icon___34R4I {\n    cursor: pointer;\n    font-size: 16px;\n    margin-right: 10px;\n    color: #a5a5a5;\n    vertical-align: middle; }\n  .mobileAppBanner__banner___2sHR_ .mobileAppBanner__bannerImage___2YmKm {\n    width: 34px;\n    height: 34px;\n    margin-right: 10px; }\n  .mobileAppBanner__banner___2sHR_ .mobileAppBanner__openBtn___3xjAX {\n    float: right;\n    margin-top: 2px;\n    font-size: 13px;\n    height: 29px; }\n", ""]);

// exports
exports.locals = {
	"banner": "mobileAppBanner__banner___2sHR_",
	"message": "mobileAppBanner__message___1anh5",
	"appName": "mobileAppBanner__appName___3lntp",
	"icon": "mobileAppBanner__icon___34R4I",
	"bannerImage": "mobileAppBanner__bannerImage___2YmKm",
	"openBtn": "mobileAppBanner__openBtn___3xjAX"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/MobileAppBanner/mobileAppBanner.scss
// module id = 3942
// module chunks = 6